<!-- Rendered inside the lot-details vb-dialog, which owns the title. -->
<span class="bid-history-subtitle">Tie bids go to the bidder who placed the earliest bid</span>
<br/>
<span class="bid-history-subtitle">Your username will be hidden from other bidders</span>
<table class="bid-history-table" *ngIf="
        !isLoading &&
        bidHistory &&
        bidHistory.length > 0
    ">
    <thead>
        <tr>
            <th>Date/Time</th>
            <th>Username</th>
            <th>Bid</th>
        </tr>
    </thead>
    <tbody>
        <tr *ngFor="let bid of bidHistory">
            <td>{{ bid.dateTimePlaced | vbDateTime }}</td>
            <td class="vb-masked">{{ bid.bidderName }}</td>
            <td>
                {{ bid.amount | currency }}
                <span *ngIf="bid.isProxy" class="proxy-text">(Proxy)</span>
            </td>
        </tr>
    </tbody>
</table>
 <div
    *ngIf="
        !isLoading &&
        bidHistory &&
        bidHistory.length === 0
    "
    class="text-center no-data-text mt-4">
    <h3 class="fw-normal">No data to show at the moment.</h3>
</div>
<!-- Spinner -->
<div *ngIf="isLoading" class="vb-spinner-box vb-spinner-box--inline">
    <vb-spinner size="sm" label="Loading bids"></vb-spinner>
</div>
